<div class="main_body">
  <div class="contents contents--user-dialog">
    <div class="contents_section_group">
      <section class="contents__section">
        <app-expert-dialog-inner />
      </section>
    </div>
  </div>
</div>
